import React, { useEffect, useState, useLayoutEffect } from 'react';
import Loader from '../components/loader';
import AuthService from "../services/auth.service";
import { useNavigate } from 'react-router-dom';
import Sports from '../components/sports';
import Recentplayed from '../components/recent-played';
import Livecasino from '../components/live-casino'
import Cricket from '../components/cricket';
import Onfire from '../components/onfire';
import Trusted from '../components/trusted'
import SubFooter from '../components/sub-footer'
import Slidernew from '../components/sliderNew'
import Header from '../components/header';
import Footer from '../components/footer';
import Forans from '../assets/images/fornImg.png'
import Virat from '../assets/images/viratRahul.png'
import SliderWeb from '../components/sliderWeb';
import SubFooterWeb from '../components/sub-footerWeb';
import SideBar from '../components/sideMenu';
import useDevice from "../hooks/useDevice";

function Home() {
  const [isPageloading, setIsPageLoading] = useState(false);
  const [message, setMessage] = useState("");
  const [gameList, setGameList] = useState<any>([]);
  const navigate = useNavigate();
  const isMobile = useDevice();

  useLayoutEffect(() => {
    if (isPageloading) {
      document.body.style.overflow = "hidden";
      document.body.style.height = "100%";
    } else {
      // if (!isPageloading) {
      document.body.style.overflow = "auto";
      document.body.style.height = "auto";
    }

  }, [isPageloading]);

  useEffect(() => {
    // getGamesList();

    // eslint-disable-next-line
  }, []);


  function getGamesList() {
    setIsPageLoading(true);
    AuthService.getGames('sports', 'fetch_games', 4)
      .then(
        (response) => {
          //console.log(response.data);
          if (response.status === 200) {
            setGameList(response?.data);
          } else {
            setMessage(response?.message);
          }
        }
      ).catch((error) => {
        //console.log(error?.status, error?.response?.data?.status)
        const message = error?.response?.data?.error_description;
        setMessage(message);
        if (error?.response?.data?.status === 401) {
          localStorage.removeItem("w_token");
          navigate('/login');
        }
      }).finally(() => {
        setIsPageLoading(false);
      });
  }


  return (
    <>
      {isPageloading && <Loader />}

      <section className='sideBarSection'>
        <SideBar />
        <section className='mainContent'>
          <Header />
          <div className='webCastomMargen'>
            <div className="container home">
              <div className="row">
                <div className='col-12'>
                  {isMobile ?
                    <div className="mobileBanner">
                      <Slidernew />
                    </div>
                    :
                    <div className="webBanner">
                      <SliderWeb />
                    </div>
                  }
                  {/* <Banner /> */}
                </div>
                <div className="col-12">
                  <div className='d-flex justify-content-between align-items-center betingChange'>
                    <button className='forans'>
                      <img src={Forans} alt="Forans" className='img-fluid' />
                      Sports Book
                    </button>
                    <button className='indianS'>
                      <img src={Virat} alt="Forans" className='img-fluid' />
                      Exchange
                    </button>
                  </div>
                </div>
                {/* <div className="col-12 d-flex py-1">
          <Link to="/deposit" style={{width:'100%',marginRight:2}}>
          <button className='depositBtn me-1'>Deposit</button>
          </Link>
          <Link to="/withdrawal" style={{width:'100%',marginLeft:2}}>
            <button className='withdrawalBtn ms-1'>Withdrawal</button>
          </Link>
        </div> */}
                <div className='col-12'>
                  {/* <Banner /> */}
                </div>
              </div>
              <div className="row">
                <div className="col-12">
                  <Sports />
                </div>
                <div className="col-12">
                  <Recentplayed />
                </div>
                <div className="col-12">
                  <Livecasino />
                </div>
                <div className="col-12">
                  <Onfire />
                </div>
                <div className="col-12">
                  <h2 className='text-center text-white boderCastom'>Our Trusted Game Partners </h2>
                </div>
                <div className="col-12">
                  <Trusted />
                </div>
                {/* <div className="col-4">
            <img src={Game1} alt="Game1" className='img-fluid'/>
        </div>
        <div className="col-4">
           <img src={Game2} alt="Game1" className='img-fluid'/>
        </div>
        <div className="col-4">
            <img src={Game3} alt="Game1" className='img-fluid'/>
        </div>
        <div className="col-4">
            <img src={Game3} alt="Game1" className='img-fluid'/>
        </div>
        <div className="col-4">
            <img src={Game1} alt="Game1" className='img-fluid'/>
        </div>
        <div className="col-4">
           <img src={Game2} alt="Game1" className='img-fluid'/>
        </div> */}
              </div>
            </div>
            {/*gameList && <Cricket gameList={gameList} />*/}
            <div className="container">
              <div className="row">
                <div className="col-12">
                  <div className='mobileFooter'>
                    <SubFooter />
                  </div>
                </div>
              </div>
            </div>

            <Footer />
          </div>
          <div className='WebFooter'>
            <SubFooterWeb />
          </div>
        </section>
      </section>
    </>
  )

}

export default Home;